
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'InfoBanner',
  props: {
    info: {
      type: String,
      default: ''
    }
  }
})
